import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'
import Wrapper from 'components/reusables/wrapper'
import Stages from './stages'
import Buttons from './buttons'

interface IProps {
  close: () => void
}

const QuestionBank = ({ close }: IProps) => {
  const { edit } = useSelector(({ blocks }: IMainState) => blocks)
  const evaluationId = edit.id
  return (
    <Wrapper shadow={false}>
      <Stages evaluationId={evaluationId} />
      <Buttons evaluationId={evaluationId} close={close} />
    </Wrapper>
  )
}

export default QuestionBank
